import { CommonCancellationsCrumbs } from './breadcrumb';

export const CancellationUnderageSearchCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Persona - Cancellazione Minore',
    path: '/cancellazioni/minori',
  },
];

export const CancellationUnderageFormCrumbs = [
  ...CancellationUnderageSearchCrumbs,
  {
    name: 'Cancellazione Minore',
    path: '/cancellazioni/minori/operazione',
  },
];
